import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { desktopHeaderHeight } from '../LayoutStyles';
import { TooltipContentDiv } from '../../../components/TooltipContentStyles';
import TooltipContent from '../../../components/TooltipContent';
import { arrowUp } from '../../../styles/utils';

export const DesktopHeaderDiv = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: ${props => props.theme.concrete};
  height: ${desktopHeaderHeight};
  ${props => props.theme.bottomDropShadow};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavItemsDiv = styled.div`
  position: absolute;
  right: 0;
  display: flex;
`;

export const HeaderSpacerDiv = styled.div`
  border-left: ${props => props.theme.defaultBorder};
  margin: 0 1.2rem;
  height: 25px;
  align-self: center;
`;

const headerIconSize = '1.8rem';
export const LogoutDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem;
  margin-right: 1rem;
  cursor: pointer;
  ${TooltipContentDiv} {
    display: none;
  }
  > svg {
    height: ${headerIconSize};
    width: ${headerIconSize};
  }
  &:hover {
    > svg {
      fill: ${props => props.theme.blue};
    }
    ${TooltipContentDiv} {
      display: flex;
    }
  }
`;

export const HeaderNavItemLink = styled(NavLink)`
  height: ${desktopHeaderHeight};
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.theme.fontStackHeader};
  color: black;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  padding: 2px 0.7rem 0;
  margin: 0 0.5rem;
  border-bottom: 2px solid transparent;
  svg {
    height: ${headerIconSize};
    width: ${headerIconSize};
    margin-right: 8px;
  }
  &.active {
    color: ${props => props.theme.blue};
    border-bottom-color: ${props => props.theme.blue};
    svg {
      fill: ${props => props.theme.blue};
    }
  }
  &:hover {
    color: ${props => props.theme.blue};
    svg {
      fill: ${props => props.theme.blue};
    }
  }
`;

export const LogoutTooltip = styled(TooltipContent)`
  padding: 0rem;
  left: auto;
  right: -3px;
  transform: unset;
  top: 54px;
  ${arrowUp({ size: 8, color: 'white', left: '50%' })};
  position: absolute;
  &::after {
    left: 53px;
  }
  svg {
    display: none;
  }
  min-height: 30px;
  width: 72px;
  p {
    font-size: 1.2rem;
  }
`;
